// base_info_view 2 
import React, { useRef, useState, useEffect } from 'react'
import BaseInfoView2_1 from './base_info_view_2_1'
import { LayoutGrid, List } from "lucide-react"

const BaseInfoView2 = ({
    baseInfoView2_1Props = {
        button_data: [
            {
                label: "卡片模式",
                icon: <LayoutGrid className="h-4 w-4" />,
                key: "卡片模式"
            },
            {
                label: "列表模式",
                icon: <List className="h-4 w-4" />,
                key: "列表模式"
            }
        ],
        defaultActiveKey: null,
        onChange: () => { }
    },
    showComponent = ["BaseInfoView2_1"]
}) => {

    return (<>
        {showComponent.includes("BaseInfoView2_1") && (
            <BaseInfoView2_1
                {...baseInfoView2_1Props}
            />)}
    </>)
}
export default BaseInfoView2
